import { withLayout } from '../../layout';

import { Security } from './security.page';

export default withLayout(Security);
